import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'product-search',
  templateUrl: '../Templates/product.search.html',
})


export class ProductSearchComponent {

  @Input()
  public query: string;

  constructor() {
    this.query = "";
  }

  @Output()
  public searchChange: EventEmitter<string> = new EventEmitter();

  public search(): void {

    this.searchChange.next(this.query);
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/product.search.ts